import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';

import { deleteDataWithParameters, getAllDetails, getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { APP_STATES, COLLEGES, HOSPITAL, SCRUTINY_VERIFICATION_LIST, UPDATE_HOSPITAL } from '../../../config/ApiConstant';
import { SkeletonbodyTemplate, Skeletonitems, defaultPageRowOptions, defaultRowOptions, paginatorLinks, showingEntries } from '../../../appconfig/Settings';
import { HospitalMasterColumnsList, ScrutinyVerificationColumnsList } from '../../../appconfig/DatatableSetting';
import { Dialog } from 'primereact/dialog';
import { AddHospitalMasterValidate } from '../../../config/Validate';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { useNavigate, useParams } from 'react-router-dom';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { commonNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { Link } from 'react-router-dom';
import { Badge } from 'primereact/badge';
import ScrutinyUploadReplyModal from '../../../components/Modal/ScrutinyUploadReplyModal';
import ScrutinyVerificationdateModal from '../../../components/Modal/ScrutinyVerificationDateModal';

export const ScrutinyVerificationList = () => {
    document.title = 'Scrutiny Verification List | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    const { fileno }: any = useParams();

    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [addHospitalMaster, setAddHospitalMaster] = useState<any>({});

    //verificaion List
    const [verificationList, setVerificationList] = useState<any>([]);
    const [userDetails, setUserDetails] = useState<any>({});

    //role
    const [roleName, setRoleName] = useState<any>(null);
    const [fileNo, setFileNo] = useState<any>(null);
    const [dateId, setDateId] = useState<any>(null);
    const [srNo, setSrNo] = useState<any>(null);
    const [selectedData, setSelectedData] = useState<any>(null);
    const [replyUpload, setReplyUpload] = useState<any>([]);
    const [dateModal, setDateModal] = useState<boolean>(false);

    const [addUpdateLoader, setAddUpdateLoader] = useState<boolean>(false);
    const [uploadModal, setUploadModal] = useState<boolean>(false);
    const [editId, setEditId] = useState<any>(null);
    const [errors, setErrors] = useState<any>({});

    // useEffect
    useEffect(() => {
        // Get Token from LocalStorage
        let token: any = localStorage.getItem('token');
        let role: any = localStorage.getItem('role');

        //Token Decode
        if (!window.cn(token)) {
            const { myUserObject } = JSON.parse(window.atob(token.split('.')[1]));
            if (!window.cn(role)) {
                let roleNm = role;

                setRoleName(roleNm);

                if (!window.cn(fileno)) {
                    let fileNumber: any = atob(fileno);
                    setFileNo(fileNumber);
                    getVerificationList(fileNumber);
                }
            }
        }
    }, []);

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'StateNm') {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        setAddHospitalMaster({ ...addHospitalMaster, [name]: val });
    };

    const rightToolbarTemplate = () => {
        return (
            <>
                <Button label="Hospital List" icon="pi pi-plus" className="p-button p-button-outlined mr-3" onClick={() => navigate('/app/hospital-list')} />
                <Button label="Add Hospital Master" icon="pi pi-plus" className="p-button" onClick={() => openAddModal()} />
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined ml-3"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Get hospitalList list
    const getVerificationList = async (fileNumber: any) => {
        try {
            setPageLoad(false);
            const response = await getAllDetailsDirect(SCRUTINY_VERIFICATION_LIST + '?SrNo=' + fileNumber);

            if (response) {
                const DataList: any = response?.data;
                setUserDetails(response?.user_data);
                if (DataList.length === 0) {
                    setVerificationList([]);
                } else {
                    setVerificationList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(true);
                setVerificationList([]);
                setUserDetails({});
            }
        } catch (error: any) {
            setPageLoad(true);
            setVerificationList([]);
            setUserDetails({});
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Open add modal
    const openAddModal = () => {
        setUploadModal(true);
    };

    // Close add modal
    const closeUploadModal = () => {
        setUploadModal(false);
        setDateModal(false);
        getVerificationList(fileNo);
    };

    // Template for action
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <Button className='mb-2' onClick={() => openReplyUploadModal(rowData?.id, rowData?.SrNo, 'Reply', rowData?.reply)}>Reply</Button>
                <br />
                <Button
                    // icon="pi pi-file-arrow-up"
                    // tooltip="Upload File"
                    // tooltipOptions={{ position: 'top' }}
                    label="Upload File"
                    onClick={() => openReplyUploadModal(rowData?.id, rowData?.SrNo, 'Upload', '')}
                    disabled={rowData?.verification_date !== null ? true : false}
                />
                <br />

                {roleName === 'Registar' ? (
                    <Button className="p-button-secondary mt-2" label="Set verification Date" style={{ width: 'max-content' }} onClick={() => openDateModal(rowData?.id)} disabled={rowData?.verification_date !== null ? true : false}></Button>
                ) : null}
            </>
        );
    };

    // Open Date Modal
    const openDateModal = (id: any) => {
        setDateId(id);
        setDateModal(true);
    };

    // Open Reply Upload Modal
    const openReplyUploadModal = (id: any, fileNo: any, type: any, selected: any) => {
        let selectedArray = '';
        if (selected !== null) {
            selectedArray = selected.split(',');
        }
        setDateId(id);
        setUploadModal(true);
        setSrNo(fileNo);
        setSelectedData(selectedArray);
        setReplyUpload(type);
    };

    // Template for Verification To
    const verificationToTemplate = (rowData: any) => {
        // Verification To
        let verificationTo = JSON.parse(rowData?.verification_to);
        let verificationData = [];

        for (const [key, value] of Object.entries(verificationTo)) {
            verificationData.push(`${key} : ${value} ${`\n\n`}`);
        }

        return <>{!window.cn(rowData?.verification_to) ? <div style={{ whiteSpace: 'break-spaces' }}>{verificationData}</div> : ''}</>;
    };

    //view verificationview template
    const viewVerificationFileTemplate = (rowData: any) => {
        return (
            <>
                {!window.cn(rowData?.file_url) ? (
                    <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => viewDocument(rowData?.file_url)}>
                        View Verification Files
                    </a>
                ) : (
                    'No Files'
                )}
            </>
        );
    };

    //view Reply template
    const viewReplyFileTemplate = (rowData: any) => {
        return (
            <>
                {!window.cn(rowData?.reply_file) ? (
                    <a style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => viewDocument(rowData?.reply_file)}>
                        {' '}
                        Reply Files
                    </a>
                ) : (
                    'No Files'
                )}
            </>
        );
    };

    // View Document
    const viewDocument = (fileUrl: any) => {
        const fileName = `Verification-Data-${new Date().getTime()}`;
        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
    };

    // Get Name
    let name = `${!window.cn(userDetails?.StudL) ? userDetails?.StudL : ''} ${!window.cn(userDetails?.StudF) ? userDetails?.StudF : ''} ${!window.cn(userDetails?.StudM) ? userDetails?.StudM : ''}`;

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Scrutiny'} pageName={'Verification List'} pageTitle={'Verification List'} goToPage={true} />
            <div className="grid crud-demo mt-3">
                <div className="col-12">
                    <div className="card">
                        <div className="grid pt-2">
                            <div className="field col-12 md:col-4 mb-0">
                                <div className="flex">
                                    <b className="detail_title mr-3">Full Name : </b>
                                    <p className="detail_name">{name}</p>
                                </div>
                            </div>
                            <div className="field col-12 md:col-4 flex justify-content-center mb-0">
                                <div className="flex">
                                    <b className="detail_title mr-3">App Status :</b>
                                    <p className="detail_name">{userDetails?.appStatus === 'Approved' ? <Badge value="Approved" severity="success"></Badge> : <Badge value={userDetails?.appStatus} severity="warning"></Badge>}</p>
                                </div>
                            </div>

                            <div className="field  col-12 md:col-4 flex justify-content-end mb-0">
                                <div className="flex">
                                    <b className="detail_title mr-3">File No :</b>
                                    <p className="detail_name">{!window.cn(userDetails?.SrNo) ? userDetails?.SrNo : ''}</p>
                                </div>
                            </div>
                        </div>
                        <hr />
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={verificationList}
                                    showGridlines
                                    stripedRows
                                    className="datatable-responsive pt-2"
                                    emptyMessage="No Data Found"
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={verificationList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    removableSort
                                >
                                    {ScrutinyVerificationColumnsList.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'comment') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commonNameTemplate} />;
                                        } else if (col.field === 'created_at') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'verification_date') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'verification_to') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={verificationToTemplate} />;
                                        } else if (col.field === 'file_url') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={viewVerificationFileTemplate} style={{ minWidth: '12rem' }} />;
                                        } else if (col.field === 'reply_file') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={viewReplyFileTemplate} style={{ minWidth: '12rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {ScrutinyVerificationColumnsList.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Add Update Dialog */}
            {uploadModal === true && <ScrutinyUploadReplyModal openmodel={uploadModal} dismissClick={() => closeUploadModal()} srNo={srNo} id={dateId} selectedData={selectedData} replyUpload={replyUpload} />}

            {/* Scrutiny Verification Date Modal Start */}
            <ScrutinyVerificationdateModal openmodel={dateModal} dismissClick={() => closeUploadModal()} dateId={dateId} />
            {/* Scrutiny Verification Date Modal End */}
        </>
    );
};
